(() => {
  if (window.chungtaLanguagePickers) return;
  window.chungtaLanguagePickers = true;
  let active;
  let consumeEscapeKeyUp = false;
  const initializedControls = new WeakSet();
  const items = picker => [...picker.querySelectorAll('[data-ct-language-value]')];

  function close(restoreFocus = false) {
    if (!active) return;
    const {panel, button} = active;
    active = undefined;
    if (typeof panel.hidePopover === 'function' && panel.matches(':popover-open')) panel.hidePopover();
    panel.hidden = true;
    button.setAttribute('aria-expanded', 'false');
    if (restoreFocus) button.focus({preventScroll: true});
  }
  function position() {
    if (!active) return;
    const {button, panel} = active;
    const rect = button.getBoundingClientRect();
    const width = window.visualViewport?.width || window.innerWidth;
    const height = window.visualViewport?.height || window.innerHeight;
    panel.style.left = Math.max(12, Math.min(rect.right - panel.offsetWidth, width - panel.offsetWidth - 12)) + 'px';
    panel.style.top = (rect.bottom + panel.offsetHeight + 8 <= height - 12 ? rect.bottom + 8 : Math.max(12, rect.top - panel.offsetHeight - 8)) + 'px';
  }
  function open(picker, keyboard = false) {
    const button = picker.querySelector('[data-ct-language-trigger]');
    const panel = picker.querySelector('[data-ct-language-panel]');
    if (active?.button === button) {
      if (keyboard) (items(picker).find(item => item.getAttribute('aria-selected') === 'true') || items(picker)[0])?.focus();
      else close(true);
      return;
    }
    close();
    document.dispatchEvent(new CustomEvent('ct:selector-open', {detail: {selector: 'language'}}));
    active = {picker, button, panel};
    panel.hidden = false;
    if (typeof panel.showPopover === 'function') panel.showPopover({source: button});
    button.setAttribute('aria-expanded', 'true');
    position();
    if (keyboard) (items(picker).find(item => item.getAttribute('aria-selected') === 'true') || items(picker)[0])?.focus();
  }
  function initialize() {
    if (!customElements.get('localization-form-component')) return;
    document.querySelectorAll('[data-ct-language-picker]').forEach(picker => {
      const select = picker.querySelector('select[name="language_code"]');
      const button = picker.querySelector('[data-ct-language-trigger]');
      if (!select || !button) return;
      if (button.hidden) button.hidden = false;
      if (picker.dataset.languageReady !== 'true') picker.dataset.languageReady = 'true';
      if (!initializedControls.has(button)) {
        initializedControls.add(button);
        button.addEventListener('click', () => open(picker));
      }
      items(picker).forEach(item => {
        if (initializedControls.has(item)) return;
        initializedControls.add(item);
        item.addEventListener('click', () => {
          const select = picker.querySelector('select[name="language_code"]');
          if (item.dataset.ctLanguageValue === select.value) { close(true); return; }
          select.value = item.dataset.ctLanguageValue;
          const form = select.closest('form');
          let returnTo = form.querySelector('[name="return_to"]');
          if (!returnTo) {
            returnTo = document.createElement('input');
            returnTo.type = 'hidden';
            returnTo.name = 'return_to';
            form.appendChild(returnTo);
          }
          returnTo.value = window.location.pathname + window.location.search;
          // Retain Shopify's native localization submission and return URL.
          select.dispatchEvent(new Event('change', {bubbles: true}));
          close();
        });
      });
    });
  }
  function observePickers() {
    initialize();
    // Header hydration can replace the drawer after the initial enhancement.
    new MutationObserver(records => {
      if (records.some(record =>
        (record.target instanceof Element && record.target.closest('[data-ct-language-picker]')) ||
        [...record.addedNodes].some(node => node instanceof Element && (node.matches('[data-ct-language-picker]') || node.querySelector('[data-ct-language-picker]')))
      )) initialize();
    }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-language-ready', 'hidden']});
  }
  document.addEventListener('ct:selector-open', event => {
    if (event.detail?.selector !== 'language') close();
  });
  document.addEventListener('click', event => {
    if (active && event.target instanceof Element && !active.picker.contains(event.target)) close();
  }, true);
  document.addEventListener('keydown', event => {
    if (!(event.target instanceof Element)) return;
    const picker = event.target.closest('[data-ct-language-picker]');
    if (!picker) return;
    const button = event.target.closest('[data-ct-language-trigger]');
    if (button && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
      event.preventDefault(); open(picker, true); return;
    }
    if (!active || active.picker !== picker) return;
    const options = items(picker);
    const index = options.indexOf(document.activeElement);
    if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
      event.preventDefault(); event.stopPropagation();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
      options[next]?.focus();
    } else if (event.key === 'Escape') {
      event.preventDefault(); event.stopPropagation(); consumeEscapeKeyUp = true; close(true);
    } else if (event.key === 'Tab') close(true);
  }, true);
  document.addEventListener('keyup', event => {
    if (event.key === 'Escape' && consumeEscapeKeyUp) { consumeEscapeKeyUp = false; event.stopPropagation(); }
  }, true);
  document.addEventListener('toggle', event => {
    if (event.target instanceof HTMLDetailsElement && !event.target.open && active?.button.closest('details') === event.target) close();
  }, true);
  window.addEventListener('resize', () => close(), {passive: true});
  document.addEventListener('scroll', event => {
    if (active && event.target instanceof Element && !active.panel.contains(event.target)) position();
  }, {capture: true, passive: true});
  document.addEventListener('shopify:section:load', initialize);
  customElements.whenDefined('localization-form-component').then(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observePickers, {once: true});
  else observePickers();
})();
